import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { FiHeart } from "@react-icons/all-files/fi/FiHeart";
import "./_style.scss";
import { IconHandFist, IconMegaphone, IconPartyPopper, } from "components/Icon";
export const REACTION_ICONS = [
    { id: "Solidarity", icon: _jsx(IconHandFist, { "aria-hidden": "true" }) },
    { id: "Rallying", icon: _jsx(IconMegaphone, { "aria-hidden": "true" }) },
    { id: "Gratitude", icon: _jsx(FiHeart, { "aria-hidden": "true" }) },
    { id: "Victory", icon: _jsx(IconPartyPopper, { "aria-hidden": "true" }) },
];
function ReactionIconStack({ reactions }) {
    const countMap = Object.fromEntries(reactions.map((r) => [r.type, r.count]));
    const topReactions = [...REACTION_ICONS]
        .filter((r) => (countMap[r.id] || 0) > 0)
        .sort((a, b) => (countMap[b.id] || 0) - (countMap[a.id] || 0));
    if (topReactions.length === 0) {
        return (_jsx("span", { className: "reactions-button__icon --empty", children: _jsx(IconHandFist, { "aria-hidden": "true" }) }));
    }
    return (_jsx(_Fragment, { children: topReactions.map((r, i) => (_jsx("span", { className: `reactions-button__icon --stacked --${r.id.toLowerCase()}${i === 2 ? " --mobile-hidden" : ""}`, style: { zIndex: 4 - i }, children: r.icon }, r.id))) }));
}
export default ReactionIconStack;
